<template>
    <div class="notification is-info">
        Location services are required for this event. Please enable location services and restart the app to continue.
    </div>
</template>